import styled from 'styled-components';

export const ButtonIconReadMore = styled.button`
  background-color: var(--theme-background-navy-background-color);
  border: 1px solidvar(--theme-background-navy-background-color);
  border-radius: 10px;
  color: white;
  display: inline-flex;
  align-items: center;
  font-weight: bold;
  justify-content: center;
  transition: ease 250ms;
  padding: 15px 30px;

  &:before {
    content: '+';
    position: relative;
    left: -5px;
    top: -2px;
    font-size: 20px;
  }
`;
